import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {Student, StudentsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const STUDENT_URL = `${API_URL}/student`

const getStudents = (query: string): Promise<StudentsQueryResponse> => {
  return axios.get(`${STUDENT_URL}?${query}`)
}

const createStudent = (student: Student): Promise<Student | undefined> => {
  return axios.post(STUDENT_URL, student)
}

const updateStudent = (student: Student): Promise<Student | undefined> => {
  return axios.patch(`${STUDENT_URL}`, student)
}

const deleteStudent = (studentId: ID): Promise<void> => {
  return axios.delete(`${STUDENT_URL}/${studentId}`)
}

export {getStudents, deleteStudent, createStudent, updateStudent}
